export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#1C1410] text-white py-16 px-6">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16">
        <div>
          <div className="mb-4">
            <span className="font-serif text-2xl font-light text-white block">Nail Studio</span>
            <span className="font-sans text-xs tracking-widest2 uppercase text-gold">by Daniela</span>
          </div>
          <p className="font-sans text-sm text-white/50 leading-relaxed max-w-xs">
            Premium custom nail art. Precision craftsmanship. Luxury finishes designed for you.
          </p>
          <div className="flex gap-4 mt-6">
            {['ri-instagram-line', 'ri-tiktok-line', 'ri-pinterest-line'].map((icon, i) => (
              <a key={i} href="#" rel="nofollow" className="w-9 h-9 flex items-center justify-center border border-white/20 text-white/50 hover:border-gold hover:text-gold transition-all duration-300 cursor-pointer">
                <i className={`${icon} text-base`}></i>
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="font-sans text-xs tracking-widest2 uppercase text-gold mb-6">
            <a href="#nav">Navigate</a>
          </h4>
          <ul className="space-y-3">
            {[
              { label: 'Services', id: 'features' },
              { label: 'Gallery', id: 'gallery' },
              { label: 'Pricing', id: 'pricing' },
              { label: 'How It Works', id: 'how-it-works' },
              { label: 'Book Appointment', id: 'booking' },
            ].map((item) => (
              <li key={item.id}>
                <button onClick={() => scrollTo(item.id)} className="font-sans text-sm text-white/50 hover:text-gold transition-colors cursor-pointer whitespace-nowrap">
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-sans text-xs tracking-widest2 uppercase text-gold mb-6">
            <a href="#contact">Contact</a>
          </h4>
          <ul className="space-y-4">
            <li className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center mt-0.5"><i className="ri-map-pin-line text-gold text-sm"></i></div>
              <span className="font-sans text-sm text-white/50 leading-relaxed">By appointment only<br />Location shared upon booking</span>
            </li>
            <li className="flex items-center gap-3">
              <div className="w-5 h-5 flex items-center justify-center"><i className="ri-instagram-line text-gold text-sm"></i></div>
              <a href="#" rel="nofollow" className="font-sans text-sm text-white/50 hover:text-gold transition-colors">@nailstudiobydaniela</a>
            </li>
            <li className="flex items-center gap-3">
              <div className="w-5 h-5 flex items-center justify-center"><i className="ri-mail-line text-gold text-sm"></i></div>
              <a href="mailto:hello@nailstudiobydaniela.com" className="font-sans text-sm text-white/50 hover:text-gold transition-colors">hello@nailstudiobydaniela.com</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-6xl mx-auto mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="font-sans text-xs text-white/30">&copy; {new Date().getFullYear()} Nail Studio by Daniela. All rights reserved.</p>
        <p className="font-sans text-xs text-white/20">Crafted with precision.</p>
      </div>
    </footer>
  );
}
